'use strict';

angular.module('licensure.services')
    .factory('FBFormTypes', ['$http', '$q', function ($http, $q) {
        var get = function (code) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/fbformtypes', {
                params: {
                    code: code
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getByCode: function (code) {
                var d = $q.defer();
                
                get(code).then(function (types) {
                    if (types.length > 0) {
                        d.resolve(types[0]);
                    }
                    else {
                        d.resolve(null);
                    }
                })

                return d.promise;
            }
        }
    }])
;